let Masonry = require('masonry-layout');

$(document).ready(function () {

    let searchRequest = null;

    $('#search-all').on('change', function () {
        $('#search-records').keyup();
    });

    $('.open-search').on('click', function (e) {
        setTimeout(function () {
            $('#search-records').focus();
        }, 0);
    });

    $('#search-records').on('keyup', delay(function (e) {
        let query = $(this).val().trim(),
            table_id = $(this).attr('data-table-id'),
            $table = $('.browse-table'),
            $loader = $('.loader'),
            $search_all = $('#search-all'),
            $table_container = $('.table_container:not(.button-container)'),
            $browse_cards = $('.browse-cards'),
            $button_container = $('.button-container'),
            view = $('.page-container').attr('data-view-type'),
            $filter = $('.filter-icons'),
            filter = '';

        if($filter.length){
            filter = $filter.attr('data-filter-id');
        }

        $table.addClass('d-none');
        $browse_cards.addClass('d-none');
        $loader.removeClass('d-none');

        $('.search-table').remove();
        $('.browse-cards.searched').remove();
        $('.no-results').remove();

        if (searchRequest) {
            searchRequest.abort();
        }

        if (query.length) {
            searchRequest = $.ajax({
                type: 'GET',
                url: '/search/',
                data: {
                    search: query,
                    table_id: table_id,
                    search_all: $search_all.is(':checked') ? 'yes' : 'no',
                    view,
                    filter
                },
                success: function (results) {
                    $loader.addClass('d-none');
                    if (results) {
                        if (view === 'card') {
                            $(results).insertAfter($browse_cards).addClass('searched');
                            let msnry = new Masonry('.browse-cards.searched', {});
                        } else {
                            $table_container.append(results);
                        }
                    } else {
                        $('.search-table').remove();
                        $('.browse-cards.searched').remove();
                        let message = `<div class="no-results text-center">No search results for <b>${query}</b></div>`;
                        if (view === 'card') {
                            $(message).insertAfter($browse_cards);
                        } else {
                            $table_container.append(
                                `<div class="no-results text-center">No search results for <b>${query}</b></div>`
                            );
                        }
                    }
                }
            });
        } else {
            $table.removeClass('d-none');
            $browse_cards.removeClass('d-none');
            $('.search-table').remove();
            $('.browse-cards.searched').remove();
            $('.no-results').remove();
            $loader.addClass('d-none');
        }
    }, 300))

    $('#find-company').on('click', function (e) {
        e.preventDefault();
        let $container = $('.create-field'),
            vat_no = $container.find('.data-input[name=vat_number]').val();

        if (!vat_no.length) {
            toastr.error(translation.select_vat_no);
        } else {
            $.ajax({
                type: 'GET',
                url: '/search/company',
                data: {
                    vat_no
                },
                success: function (res) {
                    if (!res) {
                        toastr.error(translation.invalid_vat_number);
                    } else {
                        renderCompanyFields(res, $container);
                    }
                }
            })
        }
    });

    $('#find-company-modal').on('click', function (e) {
        e.preventDefault();
        let $container = $('#create-modal'),
            vat_no = $container.find('.data-input[name=vat_number]').val();

        if (!vat_no.length) {
            toastr.error(translation.select_vat_no);
        } else {
            $.ajax({
                type: 'GET',
                url: '/search/company',
                data: {
                    vat_no
                },
                success: function (res) {
                    if (!res) {
                        toastr.error(translation.invalid_vat_number);
                    } else {
                        renderCompanyFields(res, $container);
                    }
                }
            })
        }
    });
});

function renderCompanyFields(fields, $container) {
    for (let key in fields) {
        let value = fields[key];
        if (key === 'tax_payer') {
            $($container).find(`input[name=${key}]`).prop('checked', value);
        } else if (key === 'billing_country') {
            let $target = $($container).find(`.hidden-relation[name="billing_country"]`);
            $target.val(value.id);
            $target.siblings('.relation-data-field').val(value.name);
            $target.closest('.form-group').addClass('control-highlight');
        } else {
            let $target = $($container).find(`.data-input[name=${key}]`);
            $target.val(value).trigger('keyup');
            $target.closest('.form-group').addClass('control-highlight');
        }
    }
}

function delay(callback, ms) {
    let timer = 0;
    return function () {
        let context = this, args = arguments;
        $('.search-table').remove();
        $('.no-results').remove();
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}
